<template>
  <!-- 外部链接用 <a> 标签 -->
  <a v-if="isExternalLink" :href="to" target="_blank" rel="noopener">
    <slot />
  </a>
  
  <!-- 内部路由用 <router-link> -->
  <router-link v-else v-bind="$props" custom v-slot="{ href, navigate, isActive }">
    <a :href="href" @click="handleNavigation(navigate)" :class="isActive ? 'router-link-active' : ''">
      <slot />
    </a>
  </router-link>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  name: 'AppLink',
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  computed: {
    isExternalLink() {
      return isExternal(this.to)
    },
    targetPath() {
      // 获取目标路径
      if (typeof this.to === 'string') {
        return this.to
      } else if (this.to && this.to.path) {
        return this.to.path
      }
      return ''
    }
  },
  methods: {
    handleNavigation(navigate) {
      // 防重复导航处理
      const currentPath = this.$route.path
      
      // 如果目标路径与当前路径相同，不执行导航
      if (this.targetPath === currentPath) {
        return
      }
      
      // 执行导航
      navigate()
    }
  }
}
</script>